"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Project = require("./Project");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * CellWrapper - Gère la navigation entre pages via le contexte Project
 * Ne fait JAMAIS de redirection URL, utilise uniquement le state du Project
 */const CellWrapper = ({
  children,
  link_to,
  action_log,
  onClick,
  onActionLog,
  // On ignore ces props car elles sont gérées par le parent
  id,
  className,
  style,
  styles_properties,
  position_x,
  position_y,
  size_x,
  size_y,
  logEvent,
  device_id,
  project_id,
  ...rest
}) => {
  const projectContext = (0, _react.useContext)(_Project.ProjectContext);
  const handleClick = e => {
    // Log de l'action si défini
    if (action_log && onActionLog) {
      onActionLog(action_log);
    }

    // Callback onClick personnalisé
    if (onClick) {
      onClick(e);
    }

    // Navigation si link_to est défini
    if (link_to) {
      e.preventDefault();
      e.stopPropagation();
      if (logEvent) {
        logEvent({
          device_id,
          project_id,
          type: 'click_link',
          page_id: projectContext?.currentPage?.id,
          cell_id: id,
          add_datas: {
            link_to
          }
        });
      } else {
        console.warn('logEvent is not defined');
      }
      // Vérifier si c'est un lien externe (http/https)
      if (link_to.startsWith('http://') || link_to.startsWith('https://')) {
        window.open(link_to, '_blank');
        return;
      }

      // Navigation interne via le contexte Project (avec animation fade)
      if (projectContext?.navigateToPage) {
        console.log('Navigation vers page:', link_to);
        projectContext.navigateToPage(link_to);
      } else {
        console.warn('ProjectContext non disponible pour la navigation vers:', link_to);
      }
    }
  };
  const isClickable = !!(link_to || onClick);
  if (isClickable) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: '100%',
        height: '100%',
        cursor: 'pointer'
      },
      onClick: handleClick,
      "data-action-log": action_log,
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: children
  });
};
var _default = exports.default = CellWrapper;